import { redirect, RouteMatch } from "react-router-dom";
import { checkGlobalPermission } from "../services/checkGlobalPermission";

export function validatePermission(permissionTag: string) {
  return async ({ request }: { request: Request }) => {
    const permission = await checkGlobalPermission({ permissionTag });
    const hasPermission = permission.data;

    if (!hasPermission) {
      const currentUrl = new URL(request.url);
      const params = new URLSearchParams();
      params.append('r', currentUrl.pathname + currentUrl.search)
      throw redirect(`/authorizationFailed?${params.toString()}`);
    }
    return null;
  };
}

export function createCrumbHandle(label: string, key?: string) {
  const resolvedKey = key || `breadcrumbs.${label}`;
  return {
    crumb: (match: RouteMatch) => ({
      ...match,
      label,
      labelKey: resolvedKey,
      labelFallback: label,
    }),
  };
}